module.exports = __webpack_public_path__ + "static/media/resultats_6h22.c93b4a12.jpg";